import {
  GET_FEATURE_FLAGS_REQUESTED,
  GET_FEATURE_FLAGS_SUCCEEDED,
  GET_FEATURE_FLAGS_FAILED,
} from 'store/FeatureFlags/constants'

const defaultState = {
  data: {},
  isLoading: false,
}

const state = (state = defaultState, { type, payload }) => {
  switch (type) {
    case GET_FEATURE_FLAGS_REQUESTED: {
      return {
        ...state,
        isLoading: true,
      }
    }
    case GET_FEATURE_FLAGS_SUCCEEDED: {
      return {
        ...state,
        isLoading: false,
        data: payload,
      }
    }
    case GET_FEATURE_FLAGS_FAILED: {
      return {
        ...state,
        isLoading: false,
        error: payload,
      }
    }
    default:
      return state
  }
}

export default state
